import React, { Component } from "react";
import { withNavigation } from "../withNavigation";
import "../Auth.css";
class Login extends Component {

  constructor(props) {
    super(props);

    this.state = {
      mobile: "",
      password: ""
    };
  }


  handleChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };



  handleLogin = async () => {
    const { mobile, password } = this.state;
    if (!mobile || !password) {
      alert(
        "Fill all fields ❌"
      ); return;
    }

    try {
      const response = await fetch("https://api.hi-bigame.online/login",
        {
          method: "POST",
          headers: {
            "Content-Type":
              "application/json"
          },
          body: JSON.stringify({ mobile, password })
        });





      const data = await response.json();
      if (data.user) {
        // const safeUser = {
        //   id: data.user.id,
        //   username: data.user.username
        // };

        // localStorage.setItem("user",JSON.stringify(safeUser));

        localStorage.setItem("token", data.token);
        localStorage.setItem("userId", data.user.id);

        alert("Login Success ✅");

        this.props.navigate("/home", { replace: true });


      } else {
        alert(
          data.message || "Login Failed ❌");
      }
    } catch (error) {
      alert("Server Error ❌");
    }
  };





  render() {

    return (
      <div className="auth-bg">

        <div className="auth-card">

          <div className="logo"> HI-BI </div>

          <h3> Welcome Back </h3>

          <p className="field-title"> Mobile Number </p>

          <input className="auth-input" type="tel" name="mobile" placeholder="Enter Mobile Number" value={
            this.state.mobile} onChange={this.handleChange} />

          <p className="field-title"> Password </p>

          <input className="auth-input" type="password" name="password" placeholder="Enter Password"
            value={this.state.password} onChange={this.handleChange} />

          <button className="auth-btn" onClick={this.handleLogin}> Login </button>

          <div className="link" onClick={() => this.props.navigate("/forgot-password")}> Forgot Password?</div>

          <div className="link" onClick={() => this.props.navigate("/register")}>  New User?  Register</div>

        </div>

      </div>
    );

  }

}

export default withNavigation(Login);
